import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

interface PortalProps {
  children?: React.ReactNode,
  idName?: string,
  element?: string,
}

export const Portal: React.FC<PortalProps> = ({
  children,
  idName = 'ch-portal',
  element = 'div'
}) => {
  const [container] = useState(() => {
    const el = document.createElement(element)
    el.setAttribute('id', idName)
    return el
  })

  useEffect(() => {
    const divRoot = document.body

    divRoot.appendChild(container)
    return () => {
      divRoot.removeChild(container)
    }
  }, [container])

  return ReactDOM.createPortal(children, container)
}
